// extracted by mini-css-extract-plugin
export var currencyInput = "_ji-1";
export var currencySymbol = "_ji-0";